module.exports = __webpack_public_path__ + "img/historia_3-4_512.7e733a08.jpg";